// Display-feedback helpers for text inputs (counter coloring, etc).

export function getCharCounterClass(length: number, max: number): string {
  const ratio = max > 0 ? length / max : 0;
  if (ratio >= 0.8) return 'text-destructive';
  if (ratio >= 0.6) return 'text-warning';
  return 'text-muted-foreground';
}
